import { BaseInputFieldFilter, FilterLabelProps } from "@duosoftbg/nacid-components";
import React from "react";

const DescriptionFilter = ({ label = "l.searchFilter.description", ...others }: FilterLabelProps) => {
  return <BaseInputFieldFilter label={label} fieldName={"description"} {...others} />;
};

export default DescriptionFilter;
